import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";
import { Benchmark, Cashflow, Deals, Extract, LookThrough, PortalIntegrations, Portfolio } from "components/Freemium";
import { RoleComponentGuard } from "components/guards/Role-component.guard";
import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { IDealsWithInvestmentDetails } from "store/types";

import { RoleName } from "../../constants";

export const Tools: React.FC = () => {
  const [deal, setDeal] = useState<IDealsWithInvestmentDetails | null>(null);
  const { getDealsWithInvestmentDetailsAction } = useDealActions();
  const { action: getDealsWithInvestmentDetails, data: deals = [] } = useActionHook(
    getDealsWithInvestmentDetailsAction,
    {
      onSuccess: (data) => {
        setDeal(data[0]);
      }
    }
  );

  useEffect(() => {
    getDealsWithInvestmentDetails();
  }, []);

  return (
    <Stack
      sx={{
        width: "100%",
        overflow: "auto",
        gap: "16px",
        alignItems: "stretch"
      }}
      // direction="column"
    >
      <Deals />
      <Extract />
      <Cashflow />
      <Portfolio />
      <Benchmark />
      <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
        <PortalIntegrations />
      </RoleComponentGuard>
      <LookThrough deals={deals} selectedDeal={deal} handleDealChange={(deal) => setDeal(deal)} />
    </Stack>
  );
};
